import {curry} from 'ramda';

/**
 *
 * @param {string} property
 * @param {string} value
 * @returns
 */
const setRootCustomProperty = (property, value) => document.documentElement.style.setProperty(property, value)

export default curry(setRootCustomProperty);
